export default "__VITE_ASSET__CWaO2uhW__"